import { useState } from "react";
import { Cell } from "../components/Cell";
import { InactiveToggle, NotInvoicedToggle } from "../components/PatientIdentityParts";
import { COLUMN_BY_KEY, FOLLOW_UP_GROUPS, PATIENT_CONTACT_COLUMNS, emptyPatientContact, emptyRow } from "../model/materielConstants";
import {
    errorStyle,
    formSectionStyle,
    inputStyle,
    largeModalStyle,
    modalOverlayStyle,
    primaryButtonStyle,
    secondaryButtonStyle,
    verticalFieldLabelStyle,
    verticalFieldStyle,
    verticalFieldsGridStyle,
    verticalGroupFieldsStyle,
    verticalGroupSectionStyle,
    verticalGroupTitleStyle,
} from "../styles/materielStyles";
import { FollowUpGroupedFields } from "./FollowUpVerticalView";

// Ajout d'un patient au suivi avec toute sa ligne et, si demandé, son contact.
export function AddFollowUpPatientModal({ saving, onClose, onSave }) {
    const [followUp, setFollowUp] = useState({ ...emptyRow });
    const [addContact, setAddContact] = useState(false);
    const [contact, setContact] = useState({ ...emptyPatientContact });
    const [error, setError] = useState("");

    const submit = async event => {
        event.preventDefault();
        if (!followUp.patientNom.trim() || !followUp.patientPrenom.trim()) {
            setError("Le nom et le prénom sont obligatoires.");
            return;
        }
        const patient = `${followUp.patientNom.trim()} ${followUp.patientPrenom.trim()}`;
        await onSave(
            {
                ...followUp,
                patient,
                patientNom: followUp.patientNom.trim(),
                patientPrenom: followUp.patientPrenom.trim(),
            },
            addContact ? contact : null
        );
    };

    const patchFollowUp = value => {
        setFollowUp(current => ({ ...current, ...value }));
    };

    return (
        <div role="presentation" style={modalOverlayStyle} onMouseDown={onClose}>
            <div role="dialog" aria-modal="true" aria-labelledby="add-follow-up-title" style={largeModalStyle} onMouseDown={event => event.stopPropagation()}>
                <h2 id="add-follow-up-title" style={{ margin: 0, fontSize: "19px", color: "#111827" }}>Ajouter un patient</h2>
                <form onSubmit={submit} style={{ display: "grid", gap: "18px" }}>
                    {error && <div role="alert" style={errorStyle}>{error}</div>}
                    <section style={verticalGroupSectionStyle(FOLLOW_UP_GROUPS[0])}>
                        <h3 style={verticalGroupTitleStyle(FOLLOW_UP_GROUPS[0])}>Patient</h3>
                        <div style={verticalGroupFieldsStyle}>
                            <label style={verticalFieldStyle}>
                                <span style={verticalFieldLabelStyle}>Nom</span>
                                <input value={followUp.patientNom} onChange={event => patchFollowUp({ patientNom: event.target.value })} style={inputStyle} autoFocus />
                            </label>
                            <label style={verticalFieldStyle}>
                                <span style={verticalFieldLabelStyle}>Prénom</span>
                                <input value={followUp.patientPrenom} onChange={event => patchFollowUp({ patientPrenom: event.target.value })} style={inputStyle} />
                            </label>
                            <NotInvoicedToggle checked={followUp.notInvoiced} onChange={checked => patchFollowUp({ notInvoiced: checked })} />
                            <InactiveToggle inactive={followUp.inactive} onToggle={() => patchFollowUp({ inactive: !followUp.inactive })} />
                            {["cltPharmacie", "equipmentType"].map(columnKey => {
                                const column = COLUMN_BY_KEY[columnKey];
                                return (
                                    <label key={column.key} style={verticalFieldStyle}>
                                        <span style={verticalFieldLabelStyle}>{column.label}</span>
                                        <Cell
                                            row={followUp}
                                            column={column}
                                            onChange={value => patchFollowUp({ [column.key]: value })}
                                        />
                                    </label>
                                );
                            })}
                        </div>
                    </section>
                    <FollowUpGroupedFields row={followUp} onPatch={patchFollowUp} excludedGroups={["patient"]} />
                    <section style={formSectionStyle}>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px", color: "#111827", fontWeight: 700, cursor: "pointer" }}>
                            <input type="checkbox" checked={addContact} onChange={event => setAddContact(event.target.checked)} />
                            Ajouter un contact patient
                        </label>
                        {addContact && (
                            <div style={{ ...verticalFieldsGridStyle, marginTop: "14px" }}>
                                {PATIENT_CONTACT_COLUMNS.filter(column => column.key !== "patient").map(column => (
                                    <label key={column.key} style={verticalFieldStyle}>
                                        <span style={verticalFieldLabelStyle}>{column.label}</span>
                                        <Cell
                                            row={contact}
                                            column={column}
                                            onChange={value => setContact(current => ({ ...current, [column.key]: value }))}
                                        />
                                    </label>
                                ))}
                            </div>
                        )}
                    </section>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <button type="button" onClick={onClose} disabled={saving} style={secondaryButtonStyle}>Annuler</button>
                        <button type="submit" disabled={saving} style={primaryButtonStyle}>{saving ? "Ajout..." : "Ajouter le patient"}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
